import React, { Component } from 'react';

import './App.css';

import Home from "./Pages/Home";

import { Provider } from 'mobx-react';
import { } from 'mobx-react';
import AppHelperStore from './AppStore/appHelperStore';
import { BrowserRouter as Router, Route, Link, Switch, Redirect } from "react-router-dom";
import Safety from './Pages/Safety';

const appStore = new AppHelperStore();
var customError = "";

class App extends Component {

  componentWillMount = () => {
  }

  render() {
    return (
      <div>
        <Provider appStore={appStore}>
          <Router>
            <Switch>
            <Route exact path="/"
                render={() =>
                  <Redirect to="/home" />
                } />
              <Route path="/home" component={Home} />
              {/* <Route path="/" component={ Home} /> */}
              <Route path="/safety/safety" component={Safety} />
              <Route component={Home} />
              {/* <Route path="/terms_condition/terms_condition" component={TermsCondition} /> */}
            </Switch>
          </Router>
        </Provider>
      </div>
    );

  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js